(function () {
  if (window.__ncgJump) return;
  window.__ncgJump = 1;
  function salta() {
    var b = document.querySelector('._rsi-buy-now-button-product')
      || document.querySelector('._rsi-buy-now-button')
      || document.querySelector('[class*="rsi-buy-now-button"]');
    if (b) {
      b.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      var rect = b.getBoundingClientRect();
      var y = rect.top + window.pageYOffset - 90;
      var root = document.documentElement, prev = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      try { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, y); }
      root.style.scrollBehavior = prev;
      return;
    }
    var t = document.querySelector('form[action*="/cart/add"]') || document.querySelector('.product__info-wrapper');
    if (!t) return;
    var rect2 = t.getBoundingClientRect();
    var y2 = rect2.top + window.pageYOffset - 24;
    var root2 = document.documentElement, prev2 = root2.style.scrollBehavior;
    root2.style.scrollBehavior = 'auto';
    try { window.scrollTo({ top: y2, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, y2); }
    root2.style.scrollBehavior = prev2;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ncg-jump]');
    if (b) salta();
  });
})();
